export const TOP_SQL_UNKNOWN_USER_LABEL = 'System Internal'
export const TOP_SQL_UNKNOWN_USER_OPTION_VALUE = '__TOP_SQL_UNKNOWN_USER__'

// Backend reserved bucket for aggregated users outside the explicit top-user list.
export const TOP_SQL_BACKEND_OTHERS_USER = '_TIDB_TOPRU_OTHERS_USER'

export const getTopSQLUserLabel = (user?: string) =>
  user || TOP_SQL_UNKNOWN_USER_LABEL

export const getTopSQLUserOptionValue = (user?: string) =>
  user || TOP_SQL_UNKNOWN_USER_OPTION_VALUE

export const getTopSQLUserRequestValue = (user?: string) =>
  user === TOP_SQL_UNKNOWN_USER_OPTION_VALUE ? '' : user

export const isTopSQLSystemInternalUserLabel = (label?: string) =>
  label === TOP_SQL_UNKNOWN_USER_LABEL

export const isTopSQLSystemInternalUserValue = (value?: string | null) =>
  value === TOP_SQL_UNKNOWN_USER_OPTION_VALUE
